export function normalizeEmail(email?: string | null) {
  return (email ?? '').trim().toLowerCase()
}

export function isEmailValid(email?: string | null) {
  return /\S+@\S+\.\S+/.test(email ?? '')
}

export function isHeyDolfinEmail(email?: string | null) {
  return normalizeEmail(email).endsWith('@heydolfin.com')
}
